let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2lDwB")).then(() => parcelRequire('9U2Pr'));